import * as React from "react";

import { TextStyle } from "pixi.js";
import {
    Container,
    CustomPIXIComponent,
    Text,
} from "react-pixi-fiber";

import TimeFormat from "../../lib/TimeFormat";
import { IBounds } from "./Scaler";

interface IProps {
    duration: number,
    offsetX: number,
    zoom: number,
    bounds: IBounds | null,
}

const RULE_Y = 25;

export const Ticks = CustomPIXIComponent<IProps, PIXI.Graphics>({
    customApplyProps: (instance, _, {
        bounds,
        duration,
        offsetX,
        zoom,
    }) => {
        instance.clear();

        instance.lineStyle(1, 0xCCCCCC);

        instance.moveTo(offsetX, RULE_Y);
        instance.lineTo(duration * zoom + offsetX, RULE_Y);

        let tMin = -1/0;
        let tMax = 1/0;
        if (bounds) {
            tMin = bounds.min.x;
            tMax = bounds.max.x;
        }

        for (let t = 0; t < duration; t += 1) {
            if (t < tMin || t > tMax) {
                continue;
            }

            let height;
            if ((t % 60) === 0) {
                height = 15;
            } else if ((t % 5) === 0) {
                height = 10;
            } else {
                height = 5;
            }

            if (zoom < 20 && height < 15) {
                continue;
            }

            const x = t * zoom + offsetX;
            instance.moveTo(x, RULE_Y - height);
            instance.lineTo(x, RULE_Y);
        }
    },
    customDisplayObject: () => new PIXI.Graphics(),
}, 'Ticks');

class Ruler extends React.Component<IProps> {

    private textStyle = new TextStyle({
        align: 'center',
        fill: 0x999999FF,
        fontSize: 9,
    })

    public render() {
        const {
            bounds,
            duration,
            offsetX,
            zoom,
        } = this.props;

        let tMin = -1/0;
        let tMax = 1/0;
        if (bounds) {
            tMin = Math.max(0, bounds.min.x - 5);
            tMax = Math.min(duration, bounds.max.x + 5);
        }

        const labels: any[]  = [];
        for (let t = 0; t < duration; t += 1) {
            if (t < tMin || t > tMax) {
                continue;
            }

            let hasLabel = false;
            if ((t % 300) === 0) {
                hasLabel = true;
            }        
            if ((t % 150) === 0 && zoom >= 5) {
                hasLabel = true;
            }        
            if ((t % 60) === 0 && zoom >= 10) {
                hasLabel = true;
            }
            if ((t % 5) === 0 && zoom >= 20) {
                hasLabel = true;
            }
            if (!hasLabel) {
                continue;
            }

            const text = TimeFormat.toHHMMSS(t);

            const x = t * zoom + offsetX - 15;
            labels.push(<Text y={2} x={x} style={this.textStyle} text={text}  />)
        }

        return (<Container>
            <Ticks {...this.props} />
            {labels}
        </Container>)
    }
}

export default Ruler;



// WEBPACK FOOTER //
// ./src/components/Player/Ruler.tsx